import EditItemDropdown from "../EditItemDropdown";
import ReportSaveDropdownAction, {
  Props as ReportSaveDropdownActionProps,
} from "./dropdown-actions/ReportSaveDropdownAction";

type props = ReportSaveDropdownActionProps;

export default function ReportSaveDropdown({...props}: props) {
  return (
    <EditItemDropdown>
      <ReportSaveDropdownAction {...props} />
    </EditItemDropdown>
  );
}
